module.exports = __webpack_public_path__ + "img/schedule-monitoring.c49b9ded.png";